import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function FormulaBioTopics() {
  return (
    <>

      <AllSubjectTopics  subject="biology" type="formula" />

    </>
  );
}

export default FormulaBioTopics;